import './kiosk_setup.js.coffee'
import './orders.js.coffee'
import './clickable_row.js.coffee'